(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('beweis-ready');

  const revealObserver =
    'IntersectionObserver' in window && !reduceMotion
      ? new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        )
      : null;

  const selectWithin = (scope, selector) => {
    const elements = [...scope.querySelectorAll(selector)];
    if (scope.matches && scope.matches(selector)) elements.unshift(scope);
    return elements;
  };

  const initReveals = (scope) => {
    selectWithin(scope, '[data-beweis-reveal]').forEach((item) => {
      if (revealObserver) {
        revealObserver.observe(item);
      } else {
        item.classList.add('is-visible');
      }
    });
  };

  const initSteps = (scope) => {
    selectWithin(scope, '[data-beweis-steps]').forEach((stepsSection) => {
      if (stepsSection.dataset.beweisStepsInitialized === 'true') return;
      stepsSection.dataset.beweisStepsInitialized = 'true';

      const steps = [...stepsSection.querySelectorAll('[data-beweis-step]')];
      const buttons = [...stepsSection.querySelectorAll('[data-beweis-step-button]')];
      if (!steps.length || !buttons.length) return;

      const setActive = (id) => {
        buttons.forEach((button) => {
          if (button.dataset.beweisStepButton === id) {
            button.setAttribute('aria-current', 'step');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = document.getElementById(button.dataset.beweisStepButton);
          if (target) {
            target.scrollIntoView({
              behavior: reduceMotion ? 'auto' : 'smooth',
              block: 'center'
            });
          }
        });
      });

      if ('IntersectionObserver' in window) {
        const stepObserver = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (visible) setActive(visible.target.id);
          },
          { rootMargin: '-30% 0px -45% 0px', threshold: [0.1, 0.4, 0.7] }
        );
        steps.forEach((step) => stepObserver.observe(step));
      }

      setActive(steps[0].id);
    });
  };

  const initVideos = (scope) => {
    selectWithin(scope, '[data-beweis-video-toggle]').forEach((button) => {
      if (button.dataset.beweisVideoInitialized === 'true') return;
      button.dataset.beweisVideoInitialized = 'true';

      const video = button.closest('.beweis-hero, .beweis-moment-card')?.querySelector('video');
      if (!video) return;

      const updateButton = () => {
        const label = video.paused ? 'Video abspielen' : 'Video pausieren';
        button.textContent = label;
        button.setAttribute('aria-label', label);
      };

      if (reduceMotion) video.pause();

      button.addEventListener('click', () => {
        if (video.paused) {
          button.dataset.userPaused = 'false';
          video.play().catch(() => {});
        } else {
          button.dataset.userPaused = 'true';
          video.pause();
        }
        updateButton();
      });

      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);

      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) {
              video.pause();
            } else if (!reduceMotion && button.dataset.userPaused !== 'true') {
              video.play().catch(() => {});
            }
          },
          { threshold: 0.28 }
        );
        videoObserver.observe(video);
      }

      updateButton();
    });
  };

  const initAll = (scope = document) => {
    initReveals(scope);
    initSteps(scope);
    initVideos(scope);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
